import React from 'react'
import Report from './report'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { BannerStatic } from '../../../components'

const UsersReport = ({ tenantId }) => {
  const [tenantUsersReporting] = useEvent([
    {
      eventName: 'tenantUsersReporting',
      shouldTimeout: false,
      onSuccess: ({ url }) => {
        window.open(url, '_blank')
      },
      onError: () => {
        BannerStatic.show({
          label: 'There was an error when downloading the report.',
          isError: true
        })
      }
    }
  ])

  const handleUsersReportDownload = () => {
    // Although the templateName isn't used in the backend to generate the report, it is being sent to be stored on the event tracker
    tenantUsersReporting.trigger({
      tenantId
    })
  }

  return (
    <Report
      name='Toolkit User Permission Report'
      description='CSV listing active users including their roles, and permissions.'
      buttonText='Download CSV'
      onClick={handleUsersReportDownload}
      isWorking={tenantUsersReporting.isWorking}
    />
  )
}

export default UsersReport
